import { styled } from 'stitches.config'

export const FoodForDigestiveIssuesRoot = styled('div', {
  px: '$3',
  backgroundColor: '$tertiary-200',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderBottom: '9px solid transparent',
  borderTop: 0,

  '@bp2': {
    px: '$8',
    flexDirection: 'row',
  },
})
